import { FC } from 'react';
import { InterruptProcessDialog } from '../InterruptProcessDialog';
import CloserButton from '@components/icons/CloserButton/CloserButton';

type InterruptProcessButtonProps = {
  isContactsStep: boolean;
  redirectToPublicSite: () => void;
  saveProcessData?: () => Promise<void>;
};

export const InterruptProcessButton: FC<InterruptProcessButtonProps> = ({
  isContactsStep,
  redirectToPublicSite,
  saveProcessData
}) => {
  if (isContactsStep) {
    return <CloserButton onClick={redirectToPublicSite} />;
  }
  return <InterruptProcessDialog saveProcessData={saveProcessData} redirectToPublicSite={redirectToPublicSite} />;
};
